import React, { useEffect, useState } from 'react';
import { Alert, Box, LinearProgress, Snackbar, Typography } from '@mui/material';
import { OFFLINE_PROGRESS } from '../../utils/offlineLibrary';

// Shows a track being saved for offline listening, wherever it was started
const OfflineSaveProgress = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    const onProgress = (event) => setState(event.detail);
    window.addEventListener(OFFLINE_PROGRESS, onProgress);
    return () => window.removeEventListener(OFFLINE_PROGRESS, onProgress);
  }, []);

  useEffect(() => {
    if (state?.done || state?.error) {
      const timer = setTimeout(() => setState(null), state.error ? 5000 : 2500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [state]);

  return (
    <Snackbar open={Boolean(state)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{ mb: 10 }}>
      <Alert severity={state?.error ? 'error' : state?.done ? 'success' : 'info'} sx={{ minWidth: 280 }}>
        {state?.error ? state.error : state?.done
          ? `"${state.name}" is ready to play offline`
          : `Saving "${state?.name}" for offline listening`}
        {state && !state.done && !state.error && (
          <Box sx={{ mt: 1 }}>
            <LinearProgress variant={state.percent ? 'determinate' : 'indeterminate'} value={state.percent || 0} />
            <Typography variant="caption">{state.percent ? `${state.percent}%` : ''}</Typography>
          </Box>
        )}
      </Alert>
    </Snackbar>
  );
};

export default OfflineSaveProgress;
